function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { Children } from 'react';
import './PageHeader.css';
import Sticky from '../../StickyPortal/StickyPortal';
import whitelistProps from '../../utils/whitelistProps';
import getOr from '../../utils/getOr';
var getDisplayName = getOr('')('type.displayName');
var whitelist = whitelistProps();
export default function Header(_ref) {
  var sticksTo = _ref.sticksTo,
    adjustSticky = _ref.adjustSticky,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    attrs = _objectWithoutProperties(_ref, ["sticksTo", "adjustSticky", "children", "className"]);
  var additionalAttrs = whitelist(attrs);
  var childs = Children.toArray(children);
  var top = childs;
  var bottom = null;
  var subsectionIndex = childs.map(function (x) {
    return getDisplayName(x);
  }).indexOf('PageHeaderBottom');
  if (subsectionIndex !== -1) {
    top = childs.slice(0, subsectionIndex);
    bottom = childs.slice(subsectionIndex);
  }
  if (sticksTo) {
    return /*#__PURE__*/React.createElement(Sticky, {
      sticksTo: sticksTo,
      adjust: adjustSticky
    }, /*#__PURE__*/React.createElement("header", Object.assign({
      className: "_page-header _page-header--sticky ".concat(className)
    }, additionalAttrs), /*#__PURE__*/React.createElement("span", {
      className: '_page-header__top'
    }, top), bottom));
  } else {
    return /*#__PURE__*/React.createElement("header", Object.assign({
      className: "_page-header ".concat(className)
    }, additionalAttrs), /*#__PURE__*/React.createElement("span", {
      className: '_page-header__top'
    }, top), bottom);
  }
}